// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3DKSI","form":"styles_form__3xGYm"};